{
  "App": "앱",
  "Profile": "프로필",
  "My Account": "내 계정",
  "Contacts": "연락처",
  "Preferences": "기본 설정",
  "Family Language": "가족 언어",
  "Program Consent": "프로그램 동의",
  "Yes": "예",
  "No": "아니요",
  "Not submitted": "제출되지 않음",
  "See anything missing? Contact your Caring Adult": "빠진 것이 있나요? 보호자 어른에게 연락",
  "Messages": "메시지",
  "Caring Adult for": "보호자 어른 /",
  "Former Caring Adult for": "이전 보호자 어른 /",
  "Write your message here...": "여기에 메시지 작성...",
  "I need help with": "다음에 대해 도움이 필요합니다",
  "Academic": "학업",
  "After School/ Out of School": "방과 후/학교 외 시간",
  "Applying for benefits": "혜택 신청",
  "Childcare": "육아",
  "Employment / Adult Education": "취업/성인 교육",
  "Food": "음식",
  "Housing": "주택",
  "Legal services": "법률 서비스",
  "Material Resources / Clothing / Laundry": "자료 리소스/의복/세탁",
  "Mental/emotional health": "정신/정서적 건강",
  "Physical health/asthma": "신체 건강/천식",
  "Transportation": "교통편",
  "Send": "보내기",
  "Today": "오늘",
  "No messages yet": "아직 메시지가 없음",
  "No messages": "메시지 없음",
  "Start a conversation below": "아래에서 대화를 시작하세요",
  "This Caring Adult is no longer available": "이 보호자 어른은 더 이상 참여하지 않습니다",
  "No longer available ": "참여하지 않습니다 ",
  "Monday": "월요일",
  "Tuesday": "화요일",
  "Wednesday": "수요일",
  "Thursday": "목요일",
  "Friday": "금요일",
  "Saturday": "토요일",
  "Sunday": "일요일",
  "Emergency Contacts": "비상 연락처",
  "Supervisor of Social Workers for the Bronx": "브롱크스 사회복지사 감독관",
  "Student Services Manager, High School District": "학생 서비스 관리자, 고등학교 교육구",
  "Social Worker, Central Crisis Support Team": "사회복지사, 중앙 위기 지원팀(Central Crisis Support Team)",
  "Support Line": "지원 라인",
  "Suicide and Crisis Lifeline": "자살 및 위기 상담 전화(Suicide and Crisis Lifeline)",
  "Emergencies": "응급 상황",
  "If you are facing a life-threatening emergency and need help right now, call or text 911": "지금이 생명을 위협하는 응급 상황이면 도움을 받기 위해 911에 전화하거나 문자를 보내세요",
  "About New Visions": "New Visions 소개",
  "Privacy and Terms": "개인정보 보호 및 약관",
  "Homepage": "홈페이지",
  "Home Page": "홈페이지",
  "My family": "내 가족",
  "Available Services": "가용 서비스",
  "Grade": "학년",
  "School": "학교",
  "Attendance this year": "올해 출석",
  "Absences last 5 days": "지난 5일간 결석",
  "Caring Adult": "보호자 어른",
  "Message": "메시지",
  "Not available": "이용 불가",
  "Not yet assigned": "아직 할당되지 않음",
  "No absences": "결석 없음",
  "Phone not available": "전화번호가 없음",
  "Email address not available": "이메일 주소가 없음",
  "January": "1월",
  "February": "2월",
  "March": "3월",
  "April": "4월",
  "May": "5월",
  "June": "6월",
  "July": "7월",
  "August": "8월",
  "September": "9월",
  "October": "10월",
  "November": "11월",
  "December": "12월",
  "Sidenav": "옆 탐색 메뉴",
  "Home": "홈",
  "Log out": "로그아웃",
  "Accessibility": "접근성",
  "Skip to main content": "주요 콘텐츠로 건너뛰기",
  "Email": "이메일",
  "Phone": "전화",
  "Family Portal": "가족 포털",
  "Every Child and Family is Known": "가족과 어린이를 위한 교육 돌봄 지원",
  "Family Portal: Every Child and Family is Known": "가족 포털: 가족과 어린이를 위한 교육 돌봄 지원",
  "Close menu": "메뉴 닫기",
  "Open menu": "메뉴 열기",
  "Notes": "참고",
  "Send message": "메시지 보내기",
  "Languages": "언어",
  "Consent status": "동의 상태",
  "Select": "선택",
  "Language selector": "언어 선택기",
  "Sorry": "죄송합니다",
  "we couldn't find that page": "해당 페이지를 찾을 수 없습니다",
  "You are not yet authorized to log in to the Family Portal. Please reach out to your Caring Adult for access.": "아직 가족 포털에 로그인할 권한이 없습니다. 액세스하려면 돌보는 성인에게 문의하세요."
}